
import Vue from 'vue';

import { VueMaskFilter } from "v-mask";

export default Vue.filter('currency', VueMaskFilter)